import React from 'react';
import {startDigits} from '../../../../../../shared/constants';
import {RegExps} from '../../../../../../shared/constants/regexps';
import {FormValidationError, ValidationItem, validationPipe} from '../../../../../../shared/pipes';
import {InputFormView} from './InputFormView';
import {FormErrors, SubmissionError, SubmitHandler, reduxForm} from 'redux-form';
import {Forms} from '../../../../../../shared/models/forms';
import {LinkAccountForm} from '../../../../../../shared/models/linkAccount';
import {useAccountLinker} from '../../../../../../shared/hooks/useAccountLinkerHook/useAccountLinker';

import {useAppDispatch} from '../../../../../../redux';
import {addNotification} from '../../../../../../redux/actions/snackbar';
import {SnackbarNotificationType} from '../../../../../../shared/components/snackbar/model';

type ValidationError = Error & {
  data: {message: string}[];
};

const getFormErrors = (formData: LinkAccountForm) => {
  const baseValidationArray: ValidationItem[] = [
    {
      names: 'identificator',
      error: 'Обязательное поле',
      type: 'required',
    },
  ];
  const patternString = [RegExps.checkEsksoCardNumber, RegExps.checkEsksoSnilsNumber]
    .map((pattern) => pattern.toString().slice(1, -1))
    .join('|');

  const identificatorPattern = new RegExp(patternString);
  const inputValue = formData.identificator === undefined ? {identificator: ''} : formData;

  const startCardDigits = inputValue.identificator.startsWith(startDigits);
  const isCommonInputLength = inputValue.identificator.length < 11;
  const isCardDigitsLength = inputValue.identificator.length < 16;
  const isMaxCardDigitsLength = inputValue.identificator.length === 16;

  if (isCommonInputLength) {
    baseValidationArray.push({
      names: 'identificator',
      error: `Укажите номер карты (номер должен начинаться с ${startDigits}) или СНИЛС`,
      type: 'pattern',
      pattern: identificatorPattern,
    });
  } else {
    if (isCardDigitsLength && startCardDigits) {
      baseValidationArray.push({
        names: 'identificator',
        error: 'Длина номера должна равняться 16 символам',
        type: 'pattern',
        pattern: identificatorPattern,
      });
    }
    if ((isCardDigitsLength || isMaxCardDigitsLength) && !startCardDigits) {
      baseValidationArray.push({
        names: 'identificator',
        error: `Номер карты должен начинаться с ${startDigits}`,
        type: 'pattern',
        pattern: identificatorPattern,
      });
    }
  }

  return validationPipe(inputValue, baseValidationArray);
};

export interface Props {
  handleSubmit: SubmitHandler<LinkAccountForm, LinkAccountForm, string>;
  onClose: () => void;
}

const AccountLinker = ({handleSubmit, onClose}: Props) => {
  const dispatch = useAppDispatch();
  const {requestLinkingToAccount} = useAccountLinker();
  const onMainClick = (formData: LinkAccountForm) => {
    const inputValue: LinkAccountForm = formData;
    const submissionError = getFormErrors(inputValue);
    if (submissionError) {
      throw new SubmissionError(submissionError);
    }
    try {
      requestLinkingToAccount(inputValue.identificator);
      dispatch(
        addNotification({
          message: 'Запрос успешно отправлен',
          type: SnackbarNotificationType.Success,
        }),
      );
    } catch (e) {
      const error = e as ValidationError;
      const errorText = error.data?.[0]?.message || error.message || 'Ошибка. Повторите еще раз';
      const formattedError = new FormValidationError(errorText, true);
      if (!formData.identificator) {
        throw new SubmissionError({
          identificator: formattedError,
        } as FormErrors<any, FormValidationError>);
      }
      throw new SubmissionError({
        cardNumber: formattedError,
      } as FormErrors<any, FormValidationError>);
    }
    onClose();
  };

  return (
    <InputFormView
      onSubmit={(e) => {
        e?.preventDefault();
        handleSubmit(onMainClick)();
      }}
    />
  );
};

export const InputForm = reduxForm<any, any>({form: Forms.linkAccountForm})(AccountLinker);
